import React from 'react'

// import { DiAndroid, DiGithubBadge } from "react-icons/di";
// import { HiOutlinePuzzle } from "react-icons/hi";
import './ProjectCard.css'

function ProjectCard({ id, title, team_lead_name, team_members, tech_stack, team_lead_batch, description, domain, link }) {
    return (
        <div className='projectCard' data-aos="fade-up">
            <div className='project_top'>
                <h1>{title}</h1>
                <p>{description}</p>
            </div>
            <div className='project_mid'>
                <div className='project_team'>
                    <div className='project_badge'>
                        <h1 className='project_top_box1'>Project Lead</h1>
                        <h1 className='project_top_box2'>{team_lead_name}</h1>
                    </div>
                    {team_members.length > 0 && (
                        <>
                            <h1 className='project_header'>Team</h1>
                            <div className='project_mem_cont'>
                                {team_members && team_members.map((mem, id) => (
                                    <div className='project_mem' key={id}>{mem}</div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
                <div className='project_team flex-end'>
                    <div className='project_badge'>
                        <h1 className='project_top_box1'>Domain</h1>
                        <h1 className='project_top_box2'>{domain}</h1>
                    </div>
                    {tech_stack.length > 0 && (
                        <>
                            <h1 className='project_header'>Tech Stack</h1>
                            <div className='project_mem_cont flex-end'>
                                {tech_stack && tech_stack.map((tec, id) => (
                                    <div className='project_mem' key={id}>{tec}</div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>
            {/* <div className='project_bottom'>
            <h1>Links</h1>
            <div className='project_icons_card'>
                <div className='project_icon'>
                    <h3>App</h3>
                    <DiAndroid className='icon_sym' />                    
                </div>
                <div className='project_icon'>
                    <h3>Github</h3>
                    <DiGithubBadge className='icon_sym'/>                    
                </div>
                <div className='project_icon'>
                    <h3>Demo</h3>
                    <HiOutlinePuzzle className='icon_sym'/>                    
                </div>
            </div>
        </div> */}
        </div>
    )
}

export default ProjectCard